import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Dotcom2024Service } from '../../dotcom2024.service';
import { dir } from 'console';
import { environment } from '../../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { MyharrellsService } from '../../myharrells.service';
import { TakeabalancedapproachComponent } from "../../takeabalancedapproach/takeabalancedapproach.component";
import { CanonicalService } from '../../canonical.service';

@Component({
  selector: 'app-product',
  standalone: true,
  templateUrl: './product.component.html',
  styleUrl: './product.component.css',
  imports: [CommonModule, FormsModule, TakeabalancedapproachComponent]
})
export class ProductComponent {


  constructor(public router: Router, public route: ActivatedRoute, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public myHarrellsService: MyharrellsService, private canonicalService: CanonicalService) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Products/";
  productImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/ProductPhotos/";


  qtyText: string = "";
  availableToOrder: number = 0;

  imageName: string = "";
  webName: string = "";
  descriptionOpen: boolean = false;
  sizesOpen: boolean = false;

  shoppingCart: any = [];
  quantity: number = 1;

  relatedImage1ItemNmbr: string = "";
  relatedImage2ItemNmbr: string = "";
  relatedImage3ItemNmbr: string = "";
  relatedImage4ItemNmbr: string = "";
  relatedImage1ProductName: string = "";
  relatedImage2ProductName: string = "";
  relatedImage3ProductName: string = "";
  relatedImage4ProductName: string = "";


  ngOnInit(): void {
    this.dotComService.activePage = "product";

    this.title.setTitle("Harrell`s Products | Custom Fertilizers & Pesticides");
    this.meta.updateTag({ name: 'description', content: "Discover Harrell’s custom fertilizers, specialty liquids, and the nation’s largest selection of branded pesticides. Browse products and labels now!" });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'og:description', content: "Discover Harrell’s custom fertilizers, specialty liquids, and the nation’s largest selection of branded pesticides. Browse products and labels now!" });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - products" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - products" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Discover Harrell’s custom fertilizers, specialty liquids, and the nation’s largest selection of branded pesticides. Browse products and labels now!" });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - products" });
    // this.meta.updateTag({ name: 'author', content: "author tag here - products" });
    // this.dotComService.createCanonicalURL();
        this.canonicalService.updateCanonicalURL(window.location.href);



    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);

      let sku = urlParams.get('sku');
      this.dotComService.sku = sku ? sku : "";

 
      if (this.myHarrellsService.onlineOrderingInEffect) {
        //set the partnershipid so the cost and correct price comes back 
        this.dotComService.partnershipId = sessionStorage.getItem('PartnershipId');
      }

      // if (sessionStorage.getItem('EOPMode') == 'true') {
      //   this.dotComService.partnershipId = "";
      // }

      //get product details by sku
      this.dotComService.GetProductDetail().subscribe(product => {
        if (product.length > 0) {
          this.dotComService.product = product[0];
          this.dotComService.product.WebName = this.dotComService.product.WebName.trim().replace('<p>', '').replace('</p>', '');

          this.relatedImage1ItemNmbr = (product[0].RelatedItem1 != null && product[0].RelatedItem1 != "") ? product[0].RelatedItem1.substring(0, product[0].RelatedItem1.indexOf('~')).trim() : "";
          this.relatedImage2ItemNmbr = (product[0].RelatedItem2 != null && product[0].RelatedItem2 != "") ? product[0].RelatedItem2.substring(0, product[0].RelatedItem2.indexOf('~')).trim() : "";
          this.relatedImage3ItemNmbr = (product[0].RelatedItem3 != null && product[0].RelatedItem3 != "") ? product[0].RelatedItem3.substring(0, product[0].RelatedItem3.indexOf('~')).trim() : "";
          this.relatedImage4ItemNmbr = (product[0].RelatedItem4 != null && product[0].RelatedItem4 != "") ? product[0].RelatedItem4.substring(0, product[0].RelatedItem4.indexOf('~')).trim() : "";

          this.relatedImage1ProductName = (product[0].RelatedItem1 != null && product[0].RelatedItem1 != "") ? product[0].RelatedItem1.substring(product[0].RelatedItem1.indexOf('~') + 1).trim() : "";
          this.relatedImage2ProductName = (product[0].RelatedItem2 != null && product[0].RelatedItem2 != "") ? product[0].RelatedItem2.substring(product[0].RelatedItem2.indexOf('~') + 1).trim() : "";
          this.relatedImage3ProductName = (product[0].RelatedItem3 != null && product[0].RelatedItem3 != "") ? product[0].RelatedItem3.substring(product[0].RelatedItem3.indexOf('~') + 1).trim() : "";
          this.relatedImage4ProductName = (product[0].RelatedItem4 != null && product[0].RelatedItem4 != "") ? product[0].RelatedItem4.substring(product[0].RelatedItem4.indexOf('~') + 1).trim() : "";

          //set the page's title and meta tags for SEO
          this.title.setTitle(this.dotComService.product.Vendor + ' - ' + this.dotComService.product.WebName + ' - ' + this.dotComService.product.WebDescription);

          this.imageName = "";
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.productImagePaths + this.dotComService.sku.toUpperCase() + ".jpg", (exists) => {
            if (exists) {
              // Success code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
              this.imageName = this.productImagePaths + this.dotComService.sku.toUpperCase() + ".jpg";
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.productImagePaths + this.dotComService.sku.toUpperCase() + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.imageName = this.productImagePaths + this.dotComService.sku.toUpperCase() + ".png";
                } else {
                  // Fail code - use default

                  if (this.dotComService.product.Class == null && this.dotComService.product.WebClass != null && this.dotComService.product.WebClass != "") { 
                    this.dotComService.product.Class = this.dotComService.product.WebClass;
                  }

                  if (this.dotComService.product.Class.toUpperCase() == "FERT-FIN") {
                    this.imageName = this.pageImagePaths + "profertilizer_default.jpg";
                  }
                  else if (this.dotComService.product.Class.toUpperCase() == "FERT-SP-FIN") {
                    this.imageName = this.pageImagePaths + "profertilizer_sp_default.jpg";
                  }
                  else {
                    this.imageName = this.pageImagePaths + "harrellsh.png";
                  }
                }
              })
            }
          });

        }

        else if (product.length == 0 && sessionStorage.getItem('EOPMode') == 'true') {
          //eop item so get the characteristics from the B&H item info itself
          this.myHarrellsService.invoiceModeSelected = 'Detail';
          this.myHarrellsService.GetCustomersInvoices().subscribe((response: any) => {
            if (response.length > 0) {
              response = response.filter(x => x.ItemNumber == this.dotComService.sku)[0];
              this.dotComService.product = {
                ItemNmbr: response.ItemNumber.trim(),
                WebName: response.ProductDesc.trim(),
                WebDescription: 0,
                WebCategory: response.Class,
                WebClass: response.Type,
                Class: response.Type,
                FriendlyName: '',
                Vendor: response.Vendor,
                ImageURL: '',
                MasterItemNmbr: '',
                MetaTag: '',
                Name: '',
                OverrideRegStatesListingWithSeeRep: false,
                Agency: false,
                SellUofM: response.UofM.trim(),
                SellingPrice: 0
              }


              this.imageName = "";
              //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
              this.dotComService.checkIfImageExists(this.productImagePaths + this.dotComService.sku.toUpperCase() + ".jpg", (exists) => {
                if (exists) {
                  // Success code
                  //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
                  this.imageName = this.productImagePaths + this.dotComService.sku.toUpperCase() + ".jpg";
                } else {
                  // Fail code
                  this.dotComService.checkIfImageExists(this.productImagePaths + this.dotComService.sku.toUpperCase() + ".png", (exists) => {
                    if (exists) {
                      // Success code
                      this.imageName = this.productImagePaths + this.dotComService.sku.toUpperCase() + ".png";
                    } else {
                      // Fail code - use default
                      if (response.Class.toUpperCase() == "FERT-FIN") {
                        this.imageName = this.pageImagePaths + "profertilizer_default.jpg";
                      }
                      else if (response.Class.toUpperCase() == "FERT-SP-FIN") {
                        this.imageName = this.pageImagePaths + "profertilizer_sp_default.jpg";
                      }
                      else {
                        this.imageName = this.pageImagePaths + "harrellsh.png";
                      }
                    }
                  })
                }
              });
            }
          })
        }
        else
          this.dotComService.product = { ItemNmbr: '', WebName: '', WebDescription: 0, WebCategory: '', WebClass: '', Class: '', FriendlyName: '', Vendor: '', ImageURL: '', MasterItemNmbr: '', MetaTag: '', Name: '', OverrideRegStatesListingWithSeeRep: false, Agency: false };
      })

      //get linked items by sku - this gives us additonal sizes among other things
      this.dotComService.GetLinkedItems().subscribe((linkeditems: any[]) => {
        if (linkeditems.length > 0) {
          for (var i = 0; i < linkeditems.length; i++) {
            this.dotComService.productLinkedItems.push(linkeditems[i]);
          }
        }
        else
          this.dotComService.productLinkedItems = [];
      })

      //get alternate items by sku - used to display other images if set up among other things
      this.dotComService.GetAlternateItems().subscribe((alternateItems: any[]) => {
        if (alternateItems.length > 0) {
          for (var i = 0; i < alternateItems.length; i++) {
            alternateItems[i].ImageID = i + 1;
            alternateItems[i].ExtendedDescription = this.baseImagePaths + 'AltProduct-Photos/' + alternateItems[i].ExtendedDescription.replace('.JPG', '.jpg');
            this.dotComService.productAlternateItems.push(alternateItems[i]);
          }
        }
        else
          this.dotComService.productAlternateItems = [];
      })

      //if we are in bh mode check for qty availabilty
      if (sessionStorage.getItem('EOPMode') == 'true') {
        //get the total they can order for this item
        let QtyByItemArray = JSON.parse(sessionStorage.getItem('QtyByItemMax'));
        this.availableToOrder = QtyByItemArray.filter(x => x.ItemNmbr == this.dotComService.sku)[0].QtyTotal;
        this.qtyText = "(" + this.availableToOrder + " available)";
      }


    }
  }

  ViewRelatedProductDetail(itemNmbr: any): void {
    //move to the related item user clicked on
    window.location.href = '/product?sku=' + itemNmbr;
  }


  ToggleDescription(direction: string): void {
    if (direction == "open")
      this.descriptionOpen = true;
    else
      this.descriptionOpen = false;
  }

  ToggleSizes(direction: string): void {
    if (direction == "open")
      this.sizesOpen = true;
    else
      this.sizesOpen = false;
  }

  DisplaySDSPDF(itemNmbr: string) {
    this.dotComService.getDocument('sds', itemNmbr)
      .subscribe(response => {

        if (response && response.length > 0 && response[0] && response[0].FileExists == false) {
          this.dotComService.displaySDSNotice = true
        } else if (response && response.length > 0 && response[0]) {
          // window.open(response[0].DocName, "_blank"); //does not work on safari 
          var windowReference = window.open();
          windowReference.location = response[0].DocName;
        }
      });
  }


  DisplayLabelPDF(itemNmbr: string) {
    this.dotComService.getDocument('label', itemNmbr)
      .subscribe(response => {

        if (response.length == 0 || response[0].FileExists == false) {
          this.dotComService.displayLabelNotice = true
        }
        else {
          //window.open(response[0].DocName, "_blank"); //does not work on safari 
          var windowReference = window.open();
          windowReference.location = response[0].DocName;


        }
      })
  }

  ChangeImage(row: any) {
    //swaps the images - the clicked on one becomes the main image
    let clickedOnImage = window.document.getElementById(row.ImageID)
    let clickedOnImageSrc = clickedOnImage!.getAttribute('src')

    let imageMain = window.document.getElementById('imageMain')
    let oldMainSrc = imageMain!.getAttribute('src')

    imageMain!.setAttribute('src', clickedOnImageSrc!)
    clickedOnImage!.setAttribute('src', oldMainSrc!)

  }

  HideLabelNotFoundNotice() {
    this.dotComService.displayLabelNotice = false
  }

  HideSDSNotFoundNotice() {
    this.dotComService.displaySDSNotice = false
  }

  QtyLostFocus() {
    //if eop mode make sure they can not go above available qty
    if (sessionStorage.getItem('EOPMode') == 'true') {
      if (this.quantity > this.availableToOrder) {
        this.dotComService.warningText = "<b>Max Quantity Reached!</b> You only have " + this.availableToOrder + " of this item available. Your cart has been adjusted to this amount.";
        this.dotComService.displayWarning = true;
        this.quantity = this.availableToOrder;
        setTimeout(function () {
          this.dotComService.displayWarning = false;
          this.dotComService.warningText = "";
        }.bind(this), 3000);
      }
    }
  }


  AdjustQuantity(direction: string) {
    this.quantity = parseInt(this.quantity.toString());
    if (direction == "up") {

      if (sessionStorage.getItem('EOPMode') == 'true') {
        if (this.quantity < this.availableToOrder) {
          //ok do nothing they can order this many
          this.quantity = this.quantity + 1;
        }
        else {
          //alert the user and reset the qty
          this.dotComService.warningText = "<b>Max Quantity Reached!</b> You only have " + this.availableToOrder + " of this item available.";
          this.dotComService.displayWarning = true;
          this.quantity = this.availableToOrder;
          setTimeout(function () {
            this.dotComService.displayWarning = false;
            this.dotComService.warningText = "";
          }.bind(this), 3000);

        }

      }
      else
        this.quantity = this.quantity + 1;
    }
    else { //down
      this.quantity = this.quantity - 1;

      //hide the warning in case it is showing
      this.dotComService.displayWarning = false;
      this.dotComService.warningText = "";

      if (this.quantity < 1)
        this.quantity = 1;
    }
  }

  AddToCart() {

    this.shoppingCart = JSON.parse(sessionStorage.getItem("ShoppingCart") || "[]");
    if (this.shoppingCart == null)
      this.shoppingCart = [];

    var inCart = false;
    for (var i = 0; i < this.shoppingCart.length; i++) {

      if (this.shoppingCart[i].itemNmbr == this.dotComService.product.ItemNmbr) {
        inCart = true;
        break;
      }
    }
    if (inCart) {
      this.dotComService.warningText = "<b>Item In Cart!</b> Your item (" + this.dotComService.sku + ") is already in your cart.";
      this.dotComService.displayWarning = true;
      //hide the message automatically
      setTimeout(function () {
        this.dotComService.displayWarning = false;
        this.dotComService.warningText = "";
      }.bind(this), 3000);
    }
    else {

      //get the uom from the uom button that is active
      let uofToUse = this.dotComService.product.SellUofM.trim();


      if (sessionStorage.getItem('EOPMode') == 'true') {

        //adjust the qty avail for this item since they depleted some by adding some to the cart
        let QtyByItemArray2 = JSON.parse(sessionStorage.getItem('QtyByItem'));
        QtyByItemArray2.filter(x => x.ItemNmbr == this.dotComService.sku)[0].QtyTotal = QtyByItemArray2.filter(x => x.ItemNmbr == this.dotComService.sku)[0].QtyTotal - this.quantity
        //update the ShoppingCart array object in sessionstorage
        sessionStorage.setItem("QtyByItem", JSON.stringify(QtyByItemArray2))

      }

      var lineId = parseInt(this.shoppingCart.length) + 1;
      var zzItemToUse = (sessionStorage.getItem('EOPMode') == 'true') ? sessionStorage.getItem('zzItemNmbr') : '';

      this.shoppingCart.push({ lineId: lineId, itemNmbr: this.dotComService.product.ItemNmbr, qty: this.quantity, priceEach: this.dotComService.product.SellingPrice.toFixed(2), webName: this.dotComService.product.WebName + " (" + uofToUse + ") ", vendor: this.dotComService.product.Vendor, agency: this.dotComService.product.Agency, boClass: this.dotComService.product.Class, cost: this.dotComService.product.Cost, uom: uofToUse, zzItemNmbr: zzItemToUse })
      //update the ShoppingCart array object in sessionstorage
      sessionStorage.setItem("ShoppingCart", JSON.stringify(this.shoppingCart))

      //add/update order draft stored in sql server
      this.dotComService.AddUpdateDraft('dnc', 'dnc', 'dnc', 'draft', 'dnc').subscribe((response: any) => {

      })

      this.dotComService.cartCount = this.dotComService.cartCount + 1

      //let customer know the item was added to cart
      this.dotComService.successText = "<b>Success!</b> Your item (" + this.dotComService.product.WebName + ") has been added to your cart.";
      this.dotComService.displaySuccess = true;
      //hide the message automatically
      setTimeout(function () {
        this.dotComService.displaySuccess = false;
        this.dotComService.successText = "";
      }.bind(this), 2000);
    }
  }

  ContinueShopping() {
    this.router.navigate(['/products']);
  }

  GoToCart() {
    this.router.navigate(['/cart']);
  }





}


